import { gstheme } from '../style/gstheme';

// By using the same load options as much as possible avoids reloading requests
export const CONCEPT_LOAD_OPTIONS = {
    "predicates": [
        "http://www.w3.org/2004/02/skos/core#inScheme",
        "http://www.w3.org/2004/02/skos/core#prefLabel",
        "http://www.w3.org/2002/07/owl#deprecated",
        "http://purl.org/dc/terms/title",
        "http://www.w3.org/2008/05/skos-xl#prefLabel",
        "http://www.w3.org/2004/02/skos/core#narrower",
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        "https://grafsync.graphifi.com/schema/gs/status"
    ],
    "tests": [
        {
            "id": "http://www.w3.org/2008/05/skos-xl#prefLabel",
            "join": [{
                "predicate": "http://www.w3.org/2008/05/skos-xl#literalForm"
            }]
        }
    ]
};

export const CLASS_LOAD_OPTIONS = {
    predicates: [
        "http://www.w3.org/2000/01/rdf-schema#label",
        "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
        "https://grafsync.graphifi.com/schema/gs/visibility",
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        "http://www.w3.org/2002/07/owl#deprecated",
    ]
};

export const PACKAGES = {
    "https://graphifi.com/data/package/vocabularyontologymanagement": "Vocabulary and Ontology Management"
};

export const NS_GS = "https://grafsync.graphifi.com/schema/gs/";
export const USER_NAMESPACE = "https://graphifi.com/data/user/";
export const INVITATION_NAMESPACE = "https://graphifi.com/data/invitation/";
export const PROJECT_NAMESPACE = "https://grafsync.graphifi.com/data/project/";
export const GRAPH_IRI_SYSTEM = "https://grafsync.graphifi.com/graph/system";
export const GRAPH_IRI_SECURITY = "https://grafsync.graphifi.com/graph/security";

export const STATUS_ACCEPTED = "https://grafsync.graphifi.com/schema/gs/accepted";
export const STATUS_PENDING = "https://grafsync.graphifi.com/schema/gs/pending";
export const STATUS_REJECTED = "https://grafsync.graphifi.com/schema/gs/rejected";
export const STATUS_DRAFT = "https://grafsync.graphifi.com/schema/gs/draft";

export const PROJECT_COLOURS = [
    gstheme.palette.primary.main.substring(1),
    "50832C",
    "00A9E0",
    "49426A",
    "028090",
    "5D737E",
    gstheme.palette.primary.light.substring(1)
];

export const LANGS = {
    und: { en: "No Language" },
    aa: { en: "Afar" },
    ab: { en: "Abkhazian" },
    ae: { en: "Avestan" },
    af: { en: "Afrikaans" },
    ak: { en: "Akan" },
    am: { en: "Amharic" },
    an: { en: "Aragonese" },
    ar: { en: "Arabic" },
    as: { en: "Assamese" },
    av: { en: "Avaric" },
    ay: { en: "Aymara" },
    az: { en: "Azerbaijani" },
    ba: { en: "Bashkir" },
    be: { en: "Belarusian" },
    bh: { en: "Bihari" },
    bm: { en: "Bambara" },
    bg: { en: "Bulgarian" },
    bn: { en: "Bengali" },
    bo: { en: "Tibetan" },
    ca: { en: "Catalan" },
    cs: { en: "Czech" },
    cy: { en: "Welsh" },
    cz: { en: "Czech" },
    da: { en: "Danish" },
    de: { en: "German" },
    "de-ch": { en: "German (Switzerland)" },
    dv: { en: "Divehi" },
    ew: { en: "Ewe" },
    en: { en: "English" },
    "en-us": { en: "English (American)" },
    "en-au": { en: "English (Australia)" },
    "en-ca": { en: "English (Canada)" },
    "en-gb": { en: "English (British)" },
    "en-nz": { en: "English (New Zealand)" },
    el: { en: "Greek" },
    eo: { en: "Esperanto" },
    es: { en: "Spanish" },
    et: { en: "Estonian" },
    eu: { en: "Basque" },
    fa: { en: "Persian" },
    ff: { en: "Fulah" },
    fi: { en: "Finnish" },
    fj: { en: "Fijian" },
    fo: { en: "Faroese" },
    fr: { en: "French" },
    "fr-be": { en: "French (Belgium)" },
    "fr-ca": { en: "French (Canada)" },
    "fr-fr": { en: "French (French)" },
    "fr-lu": { en: "French (Luxembourg)" },
    "fr-ch": { en: "French (Switzerland)" },
    fy: { en: "Western Frisian" },
    ga: { en: "Gaelic" },
    gl: { en: "Galician" },
    gn: { en: "Guarani" },
    gu: { en: "Gujarati" },
    gv: { en: "Manx" },
    ha: { en: "Hausa" },
    hi: { en: "Hindi" },
    hr: { en: "Croatian" },
    ht: { en: "Haitian" },
    hu: { en: "Hungarian" },
    hy: { en: "Armenian" },
    hz: { en: "Herero" },
    id: { en: "Indonesian" },
    ig: { en: "Igbo" },
    is: { en: "Icelandic" },
    it: { en: "Italian" },
    ja: { en: "Japanese" },
    jv: { en: "Javanese" },
    ka: { en: "Georgian" },
    kk: { en: "Kazakh" },
    kn: { en: "Kannada" },
    ko: { en: "Korean" },
    ku: { en: "Kurdish" },
    la: { en: "Latin" },
    lb: { en: "Luxembourgish" },
    lg: { en: "Ganda" },
    ln: { en: "Lingala" },
    lo: { en: "Lao" },
    lt: { en: "Lithuanian" },
    lv: { en: "Latvian" },
    mg: { en: "Malagsay" },
    mk: { en: "Macedonian" },
    mi: { en: "Maori" },
    ml: { en: "Malayalam" },
    mn: { en: "Mongolian" },
    mr: { en: "Marathi" },
    ms: { en: "Malay" },
    mt: { en: "Maltese" },
    my: { en: "Burmese" },
    na: { en: "Macedonian" },
    nl: { en: "Dutch" },
    "nl-nl": { en: "Dutch (Netherlands)" },
    nb: { en: "Norwegian Bokmål" },
    no: { en: "Norwegian" },
    ny: { en: "Chichewa" },
    om: { en: "Oromo" },
    or: { en: "Oriya" },
    pa: { en: "Punjabi" },
    pl: { en: "Polish" },
    ps: { en: "Pushto" },
    pt: { en: "Portuguese" },
    rn: { en: "Rundi" },
    ro: { en: "Romanian" },
    ru: { en: "Russian" },
    sa: { en: "Samoan" },
    sd: { en: "Sindhi" },
    si: { en: "Sinhala" },
    sk: { en: "Slovak" },
    sl: { en: "Slovenian" },
    sn: { en: "Shona" },
    so: { en: "Somali" },
    sq: { en: "Albanian" },
    st: { en: "Sotho" },
    su: { en: "Sundanese" },
    sv: { en: "Swedish" },
    sw: { en: "Swahili" },
    ta: { en: "Tamil" },
    te: { en: "Telugu" },
    tg: { en: "Tajik" },
    th: { en: "Thai" },
    to: { en: "Tonga" },
    tr: { en: "Turkish" },
    tt: { en: "Tatar" },
    ty: { en: "Tahitian" },
    ur: { en: "Urdu" },
    uk: { en: "Ukrainian" },
    uz: { en: "Uzbek" },
    vi: { en: "Vietnamese" },
    yi: { en: "Yiddish" },
    zh: { en: "Chinese" },
    zu: { en: "Zulu" }
};

export const DATATYPES = {
    BOOLEAN: "http://www.w3.org/2001/XMLSchema#boolean",
    ANYURI: "http://www.w3.org/2001/XMLSchema#anyURI",
    DATE: "http://www.w3.org/2001/XMLSchema#date",
    DATETIME: "http://www.w3.org/2001/XMLSchema#dateTime",
    STRING: "http://www.w3.org/2001/XMLSchema#string",
    INTEGER: "http://www.w3.org/2001/XMLSchema#integer",
    DECIMAL: "http://www.w3.org/2001/XMLSchema#decimal",
    DOUBLE: "http://www.w3.org/2001/XMLSchema#double",
    FLOAT: "http://www.w3.org/2001/XMLSchema#float",
    LONG: "http://www.w3.org/2001/XMLSchema#long",
    LANGSTRING: "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
};

export const DATATYPE_LABELS = {
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString": { en: "Language Tagged String" },
    "http://www.w3.org/2001/XMLSchema#boolean": { en: "Boolean" },
    "http://www.w3.org/2001/XMLSchema#anyURI": { en: "Any URI" },
    "http://www.w3.org/2001/XMLSchema#date": { en: "Date" },
    "http://www.w3.org/2001/XMLSchema#dateTime": { en: "Date/Time" },
    "http://www.w3.org/2001/XMLSchema#string": { en: "String" },
    "http://www.w3.org/2001/XMLSchema#integer": { en: "Integer" },
    "http://www.w3.org/2001/XMLSchema#decimal": { en: "Decimal" },
    "http://www.w3.org/2001/XMLSchema#double": { en: "Double" },
    "http://www.w3.org/2001/XMLSchema#float": { en: "Float" },
    "http://www.w3.org/2001/XMLSchema#long": { en: "Long" },
    "http://www.w3.org/2000/01/rdf-schema#Literal": { en: "Literal" }
};

export const DATATYPE_LIMITS = {
    "http://www.w3.org/2001/XMLSchema#date": {
        expression: "^\\d\\d\\d\\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])?$",
        maxLength: 10
    },
    "http://www.w3.org/2001/XMLSchema#integer": {
        expression: "^[\\-+]?[0-9]{0,15}$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#long": {
        expression: "^[\\-+]?[0-9]{0,15}$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#decimal": {
        expression: "^[\\-+]?([0-9]+(\\.[0-9]+)?|\\.[0-9]+)$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#double": {
        expression: "^[\\-+]?[0-9]+(\\.[0-9]+)?([Ee][+-]?[0-9]+)?$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#float": {
        expression: "^[\\-+]?[0-9]+(\\.[0-9]+)?([Ee][+-]?[0-9]+)?$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#anyURI": {
        maxLength: 1000,
        expression: "^(?:(?:https?|ftp):\\/\\/)(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\\d{2,5})?(?:\\/\\S*)?$"
    }
};

// Application level entitlements
export const ENTITLEMENTS = {
    CAN_IMPORT: "https://graphifi.com/schema/entitlement/canImport",
    CAN_IMPORT_PROJECT: "https://graphifi.com/schema/entitlement/canImportProject",
    CAN_EXPORT_PROJECT: "https://graphifi.com/schema/entitlement/canExportProject",
    CAN_QUERY: "https://graphifi.com/schema/entitlement/canQuery",
    CAN_QUERY_PROJECT: "https://graphifi.com/schema/entitlement/canQueryProject",
    CREATE_GROUP: "https://graphifi.com/schema/entitlement/createGroup",
    EDIT_GROUP: "https://graphifi.com/schema/entitlement/editGroup",
    EDIT_INTEGRATION: "https://graphifi.com/schema/entitlement/editIntegration",
    EDIT_PERMISSIONS: "https://graphifi.com/schema/entitlement/editPermissions",
    EDIT_USER: "https://graphifi.com/schema/entitlement/editUser",
    MANAGE_INTEGRATION: "https://graphifi.com/schema/entitlement/manageIntegration",
    MANAGE_SAVED_QUERY: "https://graphifi.com/schema/entitlement/manageSavedQuery",
    MANAGE_SNAPSHOTS: "https://graphifi.com/schema/entitlement/manageSnapshot",
    SYNCHRONISE_DATA: "https://graphifi.com/schema/entitlement/synchroniseData",
    VIEW_ENTITLEMENT: "https://graphifi.com/schema/entitlement/viewEntitlement",
    VIEW_SAVED_QUERY: "https://graphifi.com/schema/entitlement/viewSavedQuery",
};

export const DEFAULT_LANG = "en";

export const MAX_INTEGRATIONNAME_LENGTH = 50;
export const MAX_USERNAME_LENGTH = 50;
export const MAX_EMAIL_LENGTH = 250;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 50;
export const MAX_GIVENNAME_LENGTH = 50;
export const MAX_FAMILYNAME_LENGTH = 50;
export const MAX_USERGROUPNAME_LENGTH = 50;

export const MAX_PROJECT_TITLE_LENGTH = 100;
export const MAX_PROJECT_DESC_LENGTH = 500;

export const MAX_COMPONENT_TITLE_LENGTH = 100;
export const MAX_COMPONENT_DESC_LENGTH = 500;
export const MAX_DEFINITION_LENGTH = 5000;

export const MAX_LITERAL_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 1000;
export const MAX_IRI_LENGTH = 100;
export const MAX_LONGIRI_LENGTH = 500;
export const MAX_TITLE_LENGTH = 100;
export const MAX_EXCLUDE_RESOURCES = 10000;
export const MAX_SUBSCRIPTIONS = 10000;

export const SAAS_MODE = "SAAS";
export const MANAGED_MODE = "MANAGED";